module.exports = __webpack_public_path__ + "files/1577cf4dcac2d1819bbd13bc3226f4fe.png";